import React from 'react';
import { TableBody, TableRow, TableCell } from './index';
import Loader from '../Loader';
import { LoadingTableCell } from '../HotelsTable/HotelsTable.styled';

interface LoadingTableBodyProps {
  isFilterLoading: boolean;
  isSortLoading?: boolean;
  isPaginationLoading?: boolean;
  cols?: number;
  loadingMessage?: string;
}

const LoadingTableBody: React.FC<LoadingTableBodyProps> = ({
  isFilterLoading,
  isSortLoading = false,
  isPaginationLoading = false,
  cols = 5,
  loadingMessage = 'Fetching data...',
}) => {
  if (!isFilterLoading && !isSortLoading && !isPaginationLoading) {
    return null;
  }

  return (
    <TableBody>
      <TableRow className="relative">
        {/* Create cells dynamically based on cols prop */}
        {[...Array(cols - 1)].map((_, i) => (
          <LoadingTableCell
            key={i}
            as={TableCell}
            align={i === 0 ? 'left' : 'center'}
            $alignCenter={i !== 0}
            $hasLoader={i === 1}
          >
            <></>
          </LoadingTableCell>
        ))}
        <TableCell>
          <Loader
            spinnerClassName="w-9 h-9"
            message={isSortLoading ? 'Sorting...' : loadingMessage}
            containerClassName="!absolute left-0 top-0 w-full h-full"
          />
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default LoadingTableBody;
